<template>
    <div v-if="dialog_measurement_calculator">
        <v-dialog
            v-model="dialog_measurement_calculator"
            scrollable   
            :persistent="true" :overlay="false"
            max-width="600px"
            transition="dialog-transition" >
            <v-card rounded="lg" class="b1" >
                <!-- //------------TITLE -->
                <v-card-title class="primary">
                    <div class="font-weight-bold b2--text">
                        CALCULATE
                    </div> 
                    <v-spacer></v-spacer>
                    <v-btn class="ml-9" @click="dialog_measurement_calculator=false" icon dark><v-icon >close</v-icon></v-btn>
                </v-card-title> 
                <v-card-text  class="pt-5 "> 
                    <v-card outlined dark min-height="50" class="px-5 py-5 mb-3">
                        <span>{{MeasuringItem?.container_measuring_units_option_key}}</span>
                        <span>({{ MeasuringItem?.container_measuring_units_key}}) :</span>
                        {{ toNumber(CalculatedItem) }}
                    </v-card>
                    <mbs-input-fields
                        v-model="input"
                        :name_items="NAME_ITEMS"
                        :name_item="NAME_ITEM"
                        :value_items="VALUE_ITEMS"
                        :field_items="DATA.FIELDS.calculate_item_measurement"
                        :select_items="DataSource"
                        />
                </v-card-text> 
                <v-divider></v-divider> 
            </v-card> 
        </v-dialog>  
    </div>
</template>

<script>  
    import DATA from "../../plugins/DATA"
    import {mapState} from "vuex" 
import { toNumber } from "../../plugins/formatNumber"
    let NAME = 'MEASUREMENT_CALCULATOR'
    export default {
        name:NAME,
        props:['data','type','printer','com_printer'], 
        data(){
            return{
                show:true, 
                DATA:DATA, 
                input:{},
                input_date:null,
                NAME_ITEMS:DATA.ITEMS.ITEMS.names,
                NAME_ITEM:"_"+DATA.ITEMS.ITEMS.name,
                VALUE_ITEMS:DATA.ITEMS.ITEMS.values,
                VALUE_ITEM:DATA.ITEMS.ITEMS.value, 
                dialog_measurement_calculator:false 
                
            } 
        }, 
        created() {
            try { 
                this.MBS.events.$on('DIALOG_YES', this.DIALOG_YES);  
                this.MBS.events.$on('ON_MEASUREMENT_CALCULATOR', this.ON_MEASUREMENT_CALCULATOR);  
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'created',
                    page:NAME, 
                }) 
            }
        },
        mounted(){
             
        },
        computed:{
            route(){
                return this.$route
            },
            vs(){
                return this.$vuetify.breakpoint
            }, 
            vsh(){
                return this.vs.height
            }, 
            /////////
            ...mapState({
                loading:state=>state.load.loading,
                processes:state=>state.load.processes,
                responses:state=>state.load.responses,
            }),
            ...mapState({
                us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
                ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
                SelectedCompany: state=> state.items['SELECTED_COMPANY'],
            }),
            ...mapState({ 
                CompanySettings: state=> state.items[(DATA.ITEMS.COMPANY_SETTINGS.values).toUpperCase()], 
                Items: state=> state.items[(DATA.ITEMS.ITEMS.values).toUpperCase()],
                JoinedItems: state=> state.join[(DATA.ITEMS.ITEMS.values).toUpperCase()], 
                ItemCategories: state=> state.items[(DATA.ITEMS.ITEM_CATEGORIES.values).toUpperCase()],
                ItemDepartments: state=> state.items[(DATA.ITEMS.ITEM_DEPARTMENTS.values).toUpperCase()],
                Brands: state=> state.items[(DATA.ITEMS.BRANDS.values).toUpperCase()],
                Manufacturers: state=> state.items[(DATA.ITEMS.MANUFACTURERS.values).toUpperCase()], 
                TaxGroups: state=> state.app[(DATA.ITEMS.TAX_GROUPS.values).toUpperCase()], 
                StockOutlets: state=> state.items[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()],
                JoinedStockOutlets: state=> state.join[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()], 
                SelectedCompany: state=> state.items["SELECTED_COMPANY"],   
                MeasuringUnits: state=> state.app['MEASURING_UNITS'], 
                MeasuringOptions: state=> state.app['MEASURING_TYPES'], 
            }),
            ItemsData(){ 
                let Items = this.Items
                let JoinedItems = this.JoinedItems
                let CalculatedItems = this.CalculatedItems 
                if (JoinedItems) {
                    return JoinedItems
                } 
                return Items
            },
            InventoryItems(){ 
                const items = this.ItemsData 
                const filtered = items?.filter(item=>{
                    const service = item.item_type_key == "service"
                    const child = item.item_type_key == "child"
                    const parent = item.item_type_key == "parent"
                    const inventory_item_code = item?.inventory_item_code
                    const inventory_item_key = item?.inventory_item_key
                    const inventory_item_keycode = inventory_item_key?inventory_item_key:inventory_item_code
                    const inventory = !inventory_item_keycode || inventory_item_keycode == "main"?true:false
                    return inventory && !service && !child && !parent
                })  
                return filtered
            },
            NotParentItems(){ 
                const items = this.ItemsData 
                const filtered = items?.filter(item=>{
                    const parent = item.item_type_key == "parent"
                    return  !parent
                })  
                return filtered
            },
             ItemWithMeasurements(){ 
                const items = this.ItemsData 
                const filtered = items?.filter(item=>{
                    const container_measuring_units_key = item.container_measuring_units_key
                    return  container_measuring_units_key?true:false
                })  
                return filtered
            }, 
            
            DataSource(){ 
                let Outlets = this.StockOutletsData 
                let Items = this.ItemWithMeasurements  
                let ItemCategories = this.ItemCategories
                let Brands = this.Brands
                let Manufacturers = this.Manufacturers
                let TaxGroups = this.TaxGroups
                let MeasuringUnits = this.MeasuringUnits
                let MeasuringOptions = this.MeasuringOptions 
                return{
                    Outlets: Outlets,
                    Items: Items,
                    ItemCategories: ItemCategories,
                    Brands: Brands,
                    Manufacturers: Manufacturers, 
                    TaxGroups: TaxGroups, 
                    MeasuringUnits: MeasuringUnits, 
                    MeasuringOptions: MeasuringOptions,  
                }
            }, 
            MeasuringItem(){
                const input = this.input
                const measuring_item_size = input?.measuring_item_size
                const item_key = input?.item_key
                const items = this.ItemsData
                return items?.find(item=>item.key == item_key)
            },
            CalculatedItem(){
                const MeasuringItem = this.MeasuringItem
                const input = this.input
                const measuring_item_size = this.toNumber(input?.measuring_item_size )
                const container_empty_size = this.toNumber(MeasuringItem?.container_empty_size)
                const container_full_size = this.toNumber(MeasuringItem?.container_full_size)
                const container_child_number = this.toNumber(MeasuringItem?.container_child_number)
                if(!measuring_item_size){return 0}

                const item_size = container_full_size - container_empty_size
                const child_size  = item_size/container_child_number
                const current_size = measuring_item_size-container_empty_size
                const number_of_child = current_size/child_size

                console.log(item_size,"item_size.........");
                console.log(child_size,"child_size.........");
                console.log(current_size,"current_size.........");
                console.log(number_of_child,"number_of_child.........");

                // if (number_of_child<container_empty_size) {
                //     return 0
                // }
                return number_of_child.toFixed(2)

            }
        },
        methods:{ 
            ON_MEASUREMENT_CALCULATOR(){ 
                try {
                    this.dialog_measurement_calculator = !this.dialog_measurement_calculator

                    
                     
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_MEASUREMENT_CALCULATOR',
                        page:NAME, 
                    }) 
                }  
            }, 
            
            ////
            DIALOG_YES(action){ 
                try {
                    if (action.code) {
                        if (action.code ===NAME+'=PAY-BILL') {
                            if (action.YES) {
                                setTimeout(() => {
                                     
                                }, this.MBS.data.ACTION_REFRESH_TIME);   
                            } else {
                                
                            }
                        }  
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'DIALOG_YES',
                        page:NAME, 
                    }) 
                }  
            }, 
        },
        beforeDestroy(){
            try {   
                this.MBS.events.$off('DIALOG_YES', this.DIALOG_YES);     
                this.MBS.events.$off('ON_MEASUREMENT_CALCULATOR', this.ON_MEASUREMENT_CALCULATOR);   
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'beforeDestroy',
                    page:NAME, 
                })
            }
        },
        watch:{
            mbs_dialog(value){ 
            },   
        } 
    }
</script>
